import { faBuilding } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { UserJsVm } from '../../shared/generated/Admin/Models/User/JavaScript/UserJsVm';

// Managers edit their own company. Admins get "All Companies" instead.
export const getMainNavCompany: () => NavRoute = () => {
	const user = getUser();
	return {
		name: "Edit Company"
		, security: sec => !!(sec.manageUsers && !sec.adminFeatures && !user?.isRealtor)
		, href: 'company/edit'
		, icon: faBuilding
		, children: getAreas()
	}
};

export const getMainNavAllCompanies: () => NavRoute = () => ({
	name: "All Companies"
	, security: sec => sec.adminFeatures
	, href: 'company/list'
	, icon: faBuilding
	, children: getAllCompaniesAreas()
});

function getAreas(): NavRoute[] {
	return [
		{
			name: 'Details'
			, exact: true
			, path: `company/edit`
            , activeNavLink: 'company/edit'
            , secondaryNav: [ 'Company', 'Details' ]
		}
	]
}

function getAllCompaniesAreas(): NavRoute[] {
	let id: string = "";
	let url = globalThis.location.href;

	if (url.includes('company/edit/')) { id = url.substring(url.lastIndexOf('/') + 1); }

	// Company list
	if (id === "") {
		return [
			{
				name: 'Company List'
				, exact: true
				, path: 'company/list'
				, activeNavLink: 'company/list'
				, secondaryNav: [ 'All Companies', 'List' ]
			}
		];
	}

	// Company details
	return [
		{
			name: 'Back'
			, exact: true
			, path: 'company/list'
		}
		, {
			name: 'Details'
			, exact: true
			, path: `company/edit/${id}`
			, activeNavLink: 'company/edit'
			, secondaryNav: [ 'All Companies', 'Edit Company', 'Details' ]
		}
	];
}

function getUser(): UserJsVm | null {
	const userJson: string | null = localStorage.getItem('user') === null
		? null
		: localStorage.getItem('user');
	if (userJson !== null) { return JSON.parse(userJson); }
	return null;
}
